import { Button as MantineButton, ButtonProps, ElementProps } from '@mantine/core';
import { variants, VariantProps } from '../styles/button/variants';

// for typing, see https://mantine.dev/guides/typescript/#components-props-types
export const Button = ({
    intent,
    appearance,
    children,
    ...props
}: VariantProps & ButtonProps & ElementProps<'button', keyof ButtonProps>) => {
    return (
        <MantineButton
            className={variants({ intent, appearance, disabled: props.disabled })}
            style={{
                // prevent mantine from setting a default here as it overrides some of our styling
                // we could use the unstyled prop instead but some of the basic styling is actually helpful
                '--button-color': undefined,
            }}
            {...props}
        >
            {children}
        </MantineButton>
    );
};
